export default __webpack_public_path__ + "static/media/yearnLogo.a99f9c9b.png";